import { useCallback, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useApi } from "../api"
import { AppHeader } from "../components/AppHeader"
import { NftCard } from "../components/NftCard"
import { ICargo } from "../interfaces"

export const NftExplorePage = () => {
  const api = useApi('SAI')
  const navi = useNavigate()
  const { t } = useTranslation()
  const [isMounted, setIsMounted] = useState(false)
  const [nftAssets, setNftAssets] = useState([])
  const fetchNftAssets = useCallback(() => {
    api.getNftAssets((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setNftAssets(cargo.info.filter((asset: any) => { return asset['status'] === 'S' }))
      }
    })
  }, [api])
  useEffect(() => {
    if (!isMounted) {
      fetchNftAssets()
    }
    setIsMounted(true)
  }, [fetchNftAssets, isMounted])
  return (
    <>
      <div className="content colorbk" style={{ backgroundImage: `url('https://ai.supercoin.network/img/bgr.jpg')`, backgroundSize: "100% 100%" }}>
        <AppHeader title="我的NFT"></AppHeader>
      </div>
      <div className="m-86 p-4 p-sm-5 text-right">
        <Button variant="success" onClick={() => {
          navi('/app/nft-pre-sale')
        }}>{t('myNft')}</Button>
      </div>
      <div className="m-86 p-2 p-sm-5">
        {nftAssets.map((nftAsset, index) => {
          return (
            <div key={index}><NftCard asset={nftAsset} /></div>
          )
        })}
      </div>
      <div className="m-86"></div>
    </>
  )
}